/* eslint-disable arrow-body-style */
import { UploadStatus } from '../enums';

import type { IVideo } from '../types';

export const generateMockUUID = (options: { index: number; name: string; timestamp: number; }) => {
  const { index, name, timestamp } = options || {};
  return `mock-uuid-${index}-${name}-${timestamp}`;
};

export const isMockUUID = (uuid: string) => uuid?.startsWith('mock-uuid-');

export const buildVideo = (video: Partial<IVideo>): IVideo => {
  const {
    status,
    origin_video_name: originVideoName,
    origin_video_time: originVideoTime,
    create_time: createTime,
    ...restVideo
  } = video;
  return {
    uuid: '',
    status: status || UploadStatus.Loading,
    origin_video: '',
    origin_video_url: '',
    origin_video_name: originVideoName || '',
    origin_video_time: originVideoTime || '',
    result_video: '',
    result_video_url: '',
    concat_video: '',
    concat_video_url: '',
    concat_video_cover: '',
    result_msg: '',
    create_time: createTime || '',
    ...restVideo,
  };
};

export const getFileSimpleName = (fileName: string): string => {
  const lastDotIndex = fileName?.lastIndexOf('.');
  if (lastDotIndex === -1) return fileName;
  return fileName?.substring(0, lastDotIndex);
};

export const transformVideos = (videos: IVideo[]): IVideo[] => {
  if (!Array.isArray(videos)) return [];
  return videos.map((video) => {
    return {
      ...video,
      status: String(video?.status) as UploadStatus,
    };
  });
};

/**
 * 判断视频是否处于 算法处理中、COS生成视频封面处理中
 * @param status 视频状态
 * @returns 视频是否处于 算法处理中、COS生成视频封面处理中
 */
export const isVideoAndCoverProcessing = (status: UploadStatus): boolean => {
  return [UploadStatus.Processing, UploadStatus.CoverGeneratting].includes(status);
};
